import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Layout from 'antd/lib/layout';
import { Content, Footer } from '../../app/components';
import { selectShowSpinner } from '../../features/spinner/ducks';
import { selectIsLoggedIn, selectAccount, logout } from '../../features/auth/ducks';
import HeaderContainer from './HeaderContainer';
import { bindActionCreators } from 'redux';
import TestToolsPanel from '../../features/test-tools/TestToolsPanel';

const mapStateToProps = state => ({
  showSpinner: selectShowSpinner(state),
  isLoggedIn: selectIsLoggedIn(state),
  account: selectAccount(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ logout }, dispatch),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class AppContainer extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    showSpinner: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
  };

  // componentDidMount() {
  //   this.tryIfDeactivated();
  // }

  componentDidUpdate() {
    var loanContEx = document.getElementsByClassName("header");
    var x = document.getElementsByClassName("admin-wrapper");
    if (x.length > 0) {
      loanContEx[0].classList.add("wideLayout");
    } else {
      loanContEx[0].classList.remove("wideLayout");
    }
  }

  // tryIfDeactivated = () => {
  //   this.intervalTester();
  //   setInterval(this.intervalTester, 30000);
  // }

  // handleResponse = (response) => {
  //   if (response.data === true)
  //     this.props.actions.logout();
  // }

  // intervalTester = () => {
  //   if (this.props.account)
  //     apiClient.get(`/account/${this.props.account.id}/checkDeactivate`).then(response => this.handleResponse(response));
  // }

  render() {
    const { children, showSpinner, isLoggedIn } = this.props;

    return (
      <Layout>
        <HeaderContainer />
        <Content showSpinner={this.props.account ? false : false}>{children}</Content>
        <Footer isLoggedIn={isLoggedIn} />
        <TestToolsPanel />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/App.js